import {Observable, Subject} from 'rxjs';
import {distinctUntilChanged} from 'rxjs/operators';
import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {isEqual} from 'lodash';
import {DashboardCarouselItemFields} from '../../types/dashboard-shared-carousel.types';
import { RegionsCarouselViewerComponent } from '../../components/regions-carousel-viewer/regions-carousel-viewer.component';

@Component({
    selector: 'app-regions-carousel-root',
    templateUrl: './regions-carousel-root.component.html',
    styleUrls: ['./regions-carousel-root.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RegionsCarouselViewerComponent]
})
export class RegionsCarouselRootComponent<T extends DashboardCarouselItemFields> implements OnInit {
  @Input() shouldDisplayLoader = false;

  /** Stream that triggers scroll to the provided item id on each emitting. */
  @Input() elementScrollManagerById$ = new Subject<T['id']>();

  /** Stream that triggers scroll to the provided item name on each emitting. */
  @Input() elementScrollManagerByName$ = new Subject<T['name']>();

  /** Contain a list of carousel items. */
  @Input() dashboardBrainParts$: Observable<T[]>;

  /** Emits active group data when a user clicks on the pill. */
  @Output() activeSectionChanged = new EventEmitter<T>();

  /** Contain a list of carousel items with ignorance of emitting the same values. */
  public brainParts$: Observable<T[]>;

  ngOnInit(): void {
    /** Update a brain parts list to avoid value emitting on each change detection cycle. */
    this.brainParts$ = this.dashboardBrainParts$.pipe(
      distinctUntilChanged(isEqual),
    );
  }

  /**
   * Notify parent component about current slide change.
   */
  public slideChanged(slideData: T): void {
    this.activeSectionChanged.emit(slideData);
  }
}
